export default __webpack_public_path__ + "static/media/FBMemberZone.d1c41d0e.png";